module.exports = __webpack_public_path__ + "assets/row-greyc4c8fc.png";